export default {
  id: 'TransactionSearchFloat',
  code: 'CN',
  text: {
    'Electronic Receipt No.': '电子收据号',
    'Search': '查询',
    '': '',
  }
}



// WEBPACK FOOTER //
// ./src/template/Floats/TransactionSearchFloat/locale.js